import { render, staticRenderFns } from "./form-row-single-document-upload-new.vue?vue&type=template&id=506bb148&scoped=true&"
import script from "./form-row-single-document-upload-new.vue?vue&type=script&lang=js&"
export * from "./form-row-single-document-upload-new.vue?vue&type=script&lang=js&"
import style0 from "./form-row-single-document-upload-new.vue?vue&type=style&index=0&id=506bb148&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506bb148",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('506bb148')) {
      api.createRecord('506bb148', component.options)
    } else {
      api.reload('506bb148', component.options)
    }
    module.hot.accept("./form-row-single-document-upload-new.vue?vue&type=template&id=506bb148&scoped=true&", function () {
      api.rerender('506bb148', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/form-rows/form-row-single-document-upload-new.vue"
export default component.exports